import { render, staticRenderFns } from "./BondStrengthDetail.vue?vue&type=template&id=63aa5cfa&scoped=true"
import script from "./BondStrengthDetail.vue?vue&type=script&lang=js"
export * from "./BondStrengthDetail.vue?vue&type=script&lang=js"
import style0 from "./BondStrengthDetail.vue?vue&type=style&index=0&id=63aa5cfa&scoped=true&lang=css"
import style1 from "./BondStrengthDetail.vue?vue&type=style&index=1&id=63aa5cfa&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa5cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63aa5cfa')) {
      api.createRecord('63aa5cfa', component.options)
    } else {
      api.reload('63aa5cfa', component.options)
    }
    module.hot.accept("./BondStrengthDetail.vue?vue&type=template&id=63aa5cfa&scoped=true", function () {
      api.rerender('63aa5cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalConsultation/components/BondStrength/BondStrengthDetail.vue"
export default component.exports